(function () {
  var PACKING_EXTRA_CENTS = 40000;

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, (window.theme && window.theme.moneyFormat) || '${{amount}}');
    }
    return 'Rs ' + Math.round(cents / 100).toLocaleString();
  }

  function getProductRoot(sectionId) {
    return (
      document.getElementById('MainProduct-' + sectionId) ||
      document.querySelector('product-info[data-section="' + sectionId + '"]')
    );
  }

  function getMainQtyInput(sectionId) {
    return (
      document.getElementById('Quantity-' + sectionId + '-Injected') ||
      document.getElementById('Quantity-' + sectionId) ||
      document.querySelector(
        'product-info[data-section="' + sectionId + '"] input[name="quantity"]'
      )
    );
  }

  function getBuyNowQtyInput(sectionId) {
    return document.getElementById('Quantity-' + sectionId + '-BuyNow');
  }

  function getStickyBar(sectionId) {
    return document.querySelector('[data-bm7-sticky-atc][data-section-id="' + sectionId + '"]');
  }

  function getUnitPriceCents(bar) {
    if (!bar) return 0;
    return parseInt(bar.getAttribute('data-unit-price') || '0', 10) || 0;
  }

  function getCompareUnitCents(bar) {
    if (!bar) return 0;
    return parseInt(bar.getAttribute('data-compare-unit-price') || '0', 10) || 0;
  }

  function getPackingExtraCents(sectionId) {
    var packing = document.querySelector('[data-bm7-packing][data-section-id="' + sectionId + '"]');
    if (!packing) return 0;
    var active = packing.querySelector('[data-packing-value="with"].is-active');
    if (!active) return 0;
    return parseInt(packing.getAttribute('data-packing-extra') || String(PACKING_EXTRA_CENTS), 10) || PACKING_EXTRA_CENTS;
  }

  function getQty(sectionId) {
    var input = getMainQtyInput(sectionId) || getBuyNowQtyInput(sectionId) || getStickyQtyInput(sectionId);
    var val = input ? parseInt(input.value, 10) : 1;
    return isNaN(val) || val < 1 ? 1 : val;
  }

  function getStickyQtyInput(sectionId) {
    var bar = getStickyBar(sectionId);
    return bar ? bar.querySelector('[data-sticky-qty-input]') : null;
  }

  function setQtyValue(input, value, min) {
    if (!input) return;
    var next = Math.max(min || 1, value);
    if (input.max) next = Math.min(next, parseInt(input.max, 10));
    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncQtyInputs(sectionId, source) {
    var main = getMainQtyInput(sectionId);
    var sticky = getStickyQtyInput(sectionId);
    var buyNow = getBuyNowQtyInput(sectionId);
    if (!main && !sticky && !buyNow) return;
    var value = source ? parseInt(source.value, 10) : getQty(sectionId);
    if (isNaN(value)) value = 1;

    [main, sticky, buyNow].forEach(function (input) {
      if (input && input !== source && parseInt(input.value, 10) !== value) {
        input.value = String(value);
      }
    });
  }

  function getPriceNode(root, sectionId) {
    return (
      document.getElementById('price-' + sectionId) ||
      document.getElementById('bm7-price-' + sectionId) ||
      (root && root.querySelector('.pdp__price')) ||
      (root && root.querySelector('.price'))
    );
  }

  function updateMainPriceDisplay(priceNode, totalText, compareTotal) {
    if (!priceNode) return;

    if (priceNode.classList.contains('pdp__price')) {
      if (compareTotal) {
        priceNode.innerHTML =
          '<span class="was">' +
          formatMoney(compareTotal) +
          '</span>' +
          totalText +
          '<span class="save">Sale</span>';
      } else {
        priceNode.textContent = totalText;
      }
      return;
    }

    var innerPrice = priceNode.querySelector('.price') || priceNode;
    if (innerPrice.classList.contains('price--on-sale')) {
      var saleEl = innerPrice.querySelector('.price-item--sale');
      if (saleEl) saleEl.textContent = totalText;
      if (compareTotal) {
        var compareEl = innerPrice.querySelector('.price__sale s.price-item--regular');
        if (compareEl) compareEl.textContent = formatMoney(compareTotal);
      }
      return;
    }

    var regularEl = innerPrice.querySelector('.price__regular > .price-item--regular');
    if (regularEl) regularEl.textContent = totalText;
  }

  function updateDisplayedPrice(sectionId, qty, unitCents, compareCents) {
    var packingExtra = getPackingExtraCents(sectionId);
    var unitTotal = unitCents + packingExtra;
    var compareUnit = compareCents > unitCents ? compareCents + packingExtra : 0;
    var total = unitTotal * qty;
    var compareTotal = compareUnit > unitTotal ? compareUnit * qty : 0;
    var totalText = formatMoney(total);
    var root = getProductRoot(sectionId);
    var priceNode = getPriceNode(root, sectionId);
    var bar = getStickyBar(sectionId);
    var stickyPrice = bar ? bar.querySelector('[data-sticky-atc-price]') : null;

    if (stickyPrice) {
      if (compareTotal) {
        stickyPrice.innerHTML =
          '<span class="was">' +
          formatMoney(compareTotal) +
          '</span>' +
          totalText;
      } else {
        stickyPrice.textContent = totalText;
      }
    }

    if (priceNode) {
      updateMainPriceDisplay(priceNode, totalText, compareTotal);
    }

    var submit =
      root &&
      (root.querySelector('#bm7-submit-' + sectionId) ||
        root.querySelector('#ProductSubmitButton-' + sectionId) ||
        root.querySelector('product-form [name="add"]'));
    if (submit) {
      var label = submit.querySelector('span');
      if (label && !submit.disabled) {
        var base = (window.variantStrings && window.variantStrings.addToCart) || 'Add to Bag';
        if (label.textContent.toLowerCase().indexOf('add') !== -1 || label.textContent.indexOf('—') !== -1) {
          label.textContent = base + ' — ' + totalText;
        }
      }
    }

    if (typeof window.bm7SyncStickyAtc === 'function') {
      window.bm7SyncStickyAtc(sectionId);
    }
  }

  function refreshUnitPrices(sectionId) {
    var bar = getStickyBar(sectionId);
    var root = getProductRoot(sectionId);
    if (!bar || !root) return;

    var hiddenId = root.querySelector('.product-variant-id');
    var variantId = hiddenId ? hiddenId.value : '';
    if (!variantId) return;

    fetch(window.location.pathname + '.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (product) {
        var variant = (product.variants || []).find(function (v) {
          return String(v.id) === String(variantId);
        });
        if (!variant) return;
        bar.setAttribute('data-unit-price', String(variant.price));
        bar.setAttribute(
          'data-compare-unit-price',
          String(variant.compare_at_price > variant.price ? variant.compare_at_price : 0)
        );
        updateDisplayedPrice(
          sectionId,
          getQty(sectionId),
          variant.price,
          variant.compare_at_price > variant.price ? variant.compare_at_price : 0
        );
      })
      .catch(function () {});
  }

  function bindPacking(sectionId) {
    var packing = document.querySelector('[data-bm7-packing][data-section-id="' + sectionId + '"]');
    if (!packing || packing.dataset.bm7PackingBound) return;
    packing.dataset.bm7PackingBound = '1';

    var hiddenInput = packing.querySelector('[data-packing-input]');
    var buttons = packing.querySelectorAll('[data-packing-value]');
    var bar = getStickyBar(sectionId);

    function applyPacking(value) {
      buttons.forEach(function (btn) {
        var active = btn.getAttribute('data-packing-value') === value;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (hiddenInput) {
        hiddenInput.value = value === 'with' ? 'Yes (+Rs 400)' : 'No';
      }
      /* Sticky unit must already match selected length (compose syncs it). */
      updateDisplayedPrice(
        sectionId,
        getQty(sectionId),
        getUnitPriceCents(bar),
        getCompareUnitCents(bar)
      );
      refreshUnitPrices(sectionId);
      if (typeof window.bm7SyncPremiumBoxCheckout === 'function') {
        window.bm7SyncPremiumBoxCheckout(sectionId);
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyPacking(btn.getAttribute('data-packing-value'));
      });
    });
  }

  function bindQty(sectionId) {
    var main = getMainQtyInput(sectionId);
    var sticky = getStickyQtyInput(sectionId);
    var buyNow = getBuyNowQtyInput(sectionId);
    var bar = getStickyBar(sectionId);

    function onQtyChange(e) {
      syncQtyInputs(sectionId, e.target);
      updateDisplayedPrice(
        sectionId,
        getQty(sectionId),
        getUnitPriceCents(bar),
        getCompareUnitCents(bar)
      );
    }

    [main, sticky, buyNow].forEach(function (input) {
      if (!input || input.dataset.bm7QtyBound) return;
      input.dataset.bm7QtyBound = '1';
      input.addEventListener('change', onQtyChange);
      input.addEventListener('input', onQtyChange);
    });

    if (sticky && !sticky.dataset.bm7QtyInit) {
      sticky.dataset.bm7QtyInit = '1';
      if (main) sticky.value = main.value;
      if (buyNow && main) buyNow.value = main.value;
    } else if (main && sticky && !main.value) {
      main.value = sticky.value || '1';
    }

    bindPacking(sectionId);

    updateDisplayedPrice(
      sectionId,
      getQty(sectionId),
      getUnitPriceCents(bar),
      getCompareUnitCents(bar)
    );
  }

  function bindBuyNowQtySync(sectionId) {
    var buyNow = getBuyNowQtyInput(sectionId);
    var main = getMainQtyInput(sectionId);
    var checkoutRow = document.querySelector('#DynamicCheckout-' + sectionId);
    if (!buyNow || !main || !checkoutRow || checkoutRow.dataset.bm7BuyNowBound) return;
    checkoutRow.dataset.bm7BuyNowBound = '1';

    checkoutRow.addEventListener(
      'click',
      function () {
        syncQtyInputs(sectionId, buyNow);
      },
      true
    );
  }

  function initBar(bar) {
    var sectionId = bar.dataset.sectionId;
    if (!sectionId || bar.dataset.qtyReady) return;
    bar.dataset.qtyReady = '1';
    bindQty(sectionId);
    bindBuyNowQtySync(sectionId);

    document.addEventListener('bm7:product-updated', function () {
      refreshUnitPrices(sectionId);
      bindQty(sectionId);
      bindBuyNowQtySync(sectionId);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event && event.data && String(event.data.sectionId) === String(sectionId)) {
          setTimeout(function () {
            refreshUnitPrices(sectionId);
            bindQty(sectionId);
            bindBuyNowQtySync(sectionId);
          }, 50);
        }
      });
    }
  }

  function resyncQtyPricesForSection(sectionId) {
    syncQtyInputs(sectionId);
    var bar = getStickyBar(sectionId);
    updateDisplayedPrice(
      sectionId,
      getQty(sectionId),
      getUnitPriceCents(bar),
      getCompareUnitCents(bar)
    );
  }

  function resyncAllQtyPrices() {
    document.querySelectorAll('product-info[data-section]').forEach(function (root) {
      var sectionId = root.getAttribute('data-section');
      if (sectionId && (getMainQtyInput(sectionId) || getBuyNowQtyInput(sectionId))) {
        resyncQtyPricesForSection(sectionId);
      }
    });
  }

  /* After back-from-checkout (bfcache) or browser form restore, qty can differ from price. */
  function scheduleQtyPriceResync() {
    requestAnimationFrame(function () {
      resyncAllQtyPrices();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bm7-sticky-atc]').forEach(initBar);
    document.querySelectorAll('product-info[data-section]').forEach(function (root) {
      var sectionId = root.getAttribute('data-section');
      if (sectionId && (getMainQtyInput(sectionId) || getBuyNowQtyInput(sectionId))) {
        bindQty(sectionId);
        bindBuyNowQtySync(sectionId);
      }
    });
    document.querySelectorAll('[data-bm7-packing]').forEach(function (packing) {
      var sectionId = packing.getAttribute('data-section-id');
      if (sectionId) bindPacking(sectionId);
    });
    scheduleQtyPriceResync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('pageshow', function () {
    scheduleQtyPriceResync();
  });

  window.bm7UpdateProductQtyPrice = function (sectionId) {
    resyncQtyPricesForSection(sectionId);
  };
})();
